import {FC} from 'react'
import {useLayout} from '../core'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {IWorkspaceState} from '../../../app/@reducer/WorkspaceRedux'

const Footer: FC = () => {

    const {classes} = useLayout()
    const {name} = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState

    return (
        <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
            {/* begin::Container */}
            <div
                className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
            >
                {/* begin::Copyright */}
                <div className="text-dark order-2 order-md-1">
                    <span className="text-muted fw-bold me-2">{new Date().getFullYear()} &copy;</span>
                    <span className="text-gray-800">
                        {name}
                    </span>
                </div>
                {/* end::Copyright */}

            </div>
            {/* end::Container */}
        </div>
    )
}

export {Footer}
